// extracted by mini-css-extract-plugin
module.exports = {"Footer":"styles_Footer___g5_r","height":"styles_height__NK_uP"};